// A log line is a MESSAGE: `{ key, values }`, where `key` is the English
// template ("{name} taps {card}") and `values` fills its placeholders. Readers
// render it through their translation catalog, so each seat reads the log in
// its own language. This module has no imports: the engine (shared with the
// server) and the client's localization layer both use it.

// Build a message. Used for a nested value (a redacted card label such as
// msg('a card')) and wherever a message is built ahead of logging. The key
// must be a string literal at the call so the extractor collects it.
export const msg = (key, values) => (values ? { key, values } : { key });

// Fill `{name}` placeholders from `values`. A value that is itself a message
// is rendered recursively through `translate`, so nested text follows the
// language of the outer text.
export function fill(text, values, translate = (key) => key) {
  if (!values) return text;
  return text.replace(/\{(\w+)\}/g, (match, name) => {
    const value = values[name];
    if (value == null) return match;
    if (typeof value === 'object' && typeof value.key === 'string') return fill(translate(value.key), value.values, translate);
    return String(value);
  });
}
